var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"province",on:{"click":_vm.goBack}},[_vm._v(_vm._s(_vm.province))]),_c('div',{staticClass:"o-echarts",attrs:{"id":_vm.id}})])}
var staticRenderFns = []

export { render, staticRenderFns }